module.exports = __webpack_public_path__ + "76248ba8d4c72bfb7e0f223c06afc2c2.svg";